import { PUSH_DATA } from './actionTypes';

export const pushEventData = (eventData, eventType) => {
    switch(eventType){
        case 'OutTime':
            return [{
                type: PUSH_DATA,
                payload: eventData
            }];
            default: break;

    }
};